import { Component, Input, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { CurrentShift } from '@app/models/shift/current-shift';
import { BaseModalComponent, EnumValues } from '@card-software/library';

@Component({
  selector: 'app-current-shift-modal',
  templateUrl: './current-shift-modal.component.html',
  styleUrl: './current-shift-modal.component.scss',
})
export class CurrentShiftModalComponent extends BaseModalComponent<CurrentShift | null> implements OnInit {
  @Input() currentShift: CurrentShift | null = null;
  @Input() shiftEnum: EnumValues = {};

  shiftControl = new FormControl<number | null>(null, [Validators.required]);
  shiftOptions: { label: string; value: number }[] = [];

  ngOnInit(): void {
    this.prepareShiftOptions();

    if (this.currentShift) {
      this.shiftControl.setValue(this.currentShift.shift);
    }
  }

  prepareShiftOptions(): void {
    this.shiftOptions = Object.keys(this.shiftEnum).map((key) => {
      const numKey = parseInt(key);
      return {
        label: this.shiftEnum[numKey],
        value: numKey,
      };
    });
  }

  onSave(): void {
    if (this.shiftControl.invalid) {
      this.shiftControl.markAsDirty();
      return;
    }

    const updatedShift: CurrentShift = {
      ...this.currentShift,
      id: this.currentShift?.id,
      shift: this.shiftControl.value!,
    };

    this.close({ action: 'save', data: updatedShift });
  }

  onClose(): void {
    this.close({ action: 'close', data: null });
  }
}
